import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';

const PrivateRoute = ({ element: Element, ...rest }) =>
{
    const location = useLocation();

    const redirectTo = location.pathname.includes("business")
        ? "/login"
        : "/login";

    return isAuthenticated() ? (
        <Element {...rest} />
    ) : (
        <Navigate to={redirectTo} />
    );
};

export default PrivateRoute;